import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import Footer from '../NewApply/Footer';
import Header from '../NewProfile/Header';
import ScrollLock from 'react-scrolllock';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/pro-solid-svg-icons';
import { Redirect } from 'react-router-dom';
import HelpPage from './HelpPage';
import { faCircle } from '@fortawesome/pro-regular-svg-icons';
import Button from '../../artzu-ui/src/Button';
import Modal from '../../artzu-ui/src/Modal';
import PtcLicense from '../../images/ptc_license.png'
import FleetPending from '../../images/fleet_pending.png'
import MapPin from '../../images/Icons/map-pin.svg'

import { withApollo } from 'react-apollo';

import gql from 'graphql-tag';

import './dashboard.css';

class NewDashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      headerTitle: 'Dashboard',
      helpOpen: false,
      pageOpen: '',
      deactivateAccount: false,
    };
  }

  getContent = () => {
    const { status, existing_uber_partner } = this.props;
    const statusNum = this.mapStatus(status);
    const middlePage = this.middlePage();
    return [
      {
        title: 'Documents Under Review',
        text: 'Our team is reviewing your documents and will create your Uber Driver account within 1 business day.',
        status: this.getIcon(true),
        class: this.getClass(1),
        pageName: 'appSubmitted',
      },
      {
        title: middlePage === 'greenlight' ? 'Go to Greenlight Hub' : 'Do Background Check',
        text:
          middlePage === 'greenlight'
            ? 'You must go to an Uber Greenlight Hub in-person to request to be added to the Autzu Fleet.'
            : 'You must complete the Uber Background Check online.',
        status: this.getIcon(statusNum > 2),
        class: this.getClass((status === 'signed_up' && existing_uber_partner ? 3 : 4) - statusNum),
        pageName: middlePage,
      },
      {
        title: existing_uber_partner ? 'Forward PTC License' : 'Wait for PTC License',
        text: existing_uber_partner
          ? 'It will take 2 days for your PTC license to be updated. Please forward the Uber email to info@autzu.com when you receive it.'
          : 'Once your Uber Driver account is active, it will take 2 days for your PTC license to be issued.',
        status: this.getIcon(false),
        class: this.getClass(5 - statusNum),
        pageName: existing_uber_partner ? 'ptcYes' : 'ptcNo',
      },
    ];
  };

  middlePage = () => {
    const { status, existing_uber_partner } = this.props;
    switch (status) {
      case 'signed_up':
      case 'ptc_pending':
        return existing_uber_partner ? 'greenlight' : 'background';
      case 'account_pending':
      case 'bgc_pending':
        return 'background';
      case 'fleet_pending':
        return 'greenlight';
      default:
        return 'greenlight';
    }
  };
  getIcon = status => <FontAwesomeIcon className="dashboard__icon" icon={status ? faCheckCircle : faCircle} />;

  openPage = (name, title) => this.setState({ pageOpen: name, helpOpen: true, headerTitle: title });

  closePage = () => this.setState({ helpOpen: false, headerTitle: 'Dashboard' });

  getClass = status => {
    switch (status) {
      case 1:
        return 'done';
      case 2:
        return 'current';
      default:
        return 'waiting';
    }
  };

  mapStatus = status => {
    switch (status) {
      case 'signed_up':
      case 'account_pending':
        return 1;
      case 'bgc_pending':
      case 'fleet_pending':
        return 2;
      case 'ptc_pending':
        return 3;
      default:
        return 4;
    }
  };

  REOPEN_ACCOUNT = gql`
    mutation reopenUser {
      reopenUser {
        user {
          fullName
          status
        }
        errors {
          message
        }
      }
    }
  `;

  CLOSE_ACCOUNT = gql`
    mutation closeUser {
      closeUser {
        user {
          fullName
          status
        }
        errors {
          message
        }
      }
    }
  `;

  toggleClose = () => {
    this.props.client
      .mutate({
        mutation: this.props.status === 'closed' ? this.REOPEN_ACCOUNT : this.CLOSE_ACCOUNT,
      })
      .then(() => this.props.loadData());
  };

  toggleDeactivateModal = () => this.setState({ deactivateAccount: !this.state.deactivateAccount });

  render() {
    const { history, status } = this.props;
    const { headerTitle, helpOpen, pageOpen } = this.state;
    if (status === 'operating') return <Redirect to="/dashboard" />;
    return (
      <Fragment>
        <div className="apply__progress--header">
          <div className="apply__progress--header-content container">
            <Header
              title={headerTitle}
              persistentTitle
              disable
              back
              onClick={() => (helpOpen ? this.closePage() : history.goBack())}
            />
          </div>
        </div>
        <Footer
          label="Contact Us"
          back
          active
          onBackClick={() => (helpOpen ? this.closePage() : history.goBack())}
          onNextClick={() => history.push('./contact')}
        />
        <Modal open={this.state.deactivateAccount}>
          <div className="profile__deactivate-account">
            {' '}
            <div className="profile__deactivate-account--text">
              {' '}
              {status === 'closed'
                ? 'Your request will be processed in 1-2 business days. We will contact you about next steps.'
                : 'Deactivating your Autzu account will prevent you from being able to book vehicles. If you are an operating driver, we will have your Uber account removed from the Autzu fleet within 1 business day. You can reactivate your account at any time!'}{' '}
            </div>
            <div className="profile__deactivate-account--actions">
              <Button
                className="profile__deactivate-account--button"
                label="Cancel"
                onClick={() => this.toggleDeactivateModal()}
                color="#414141"
              />{' '}
              <Button
                className="profile__deactivate-account--button"
                label={status === 'closed' ? 'Reactivate' : 'Deactivate'}
                onClick={() => {
                  this.toggleClose();
                  this.toggleDeactivateModal();
                }}
              />
            </div>
          </div>
        </Modal>
        <div className="apply">
          <div className="apply__body container apply__body--progress">
            <ScrollLock>
              <div className="dashboard__container">
                {status === 'ptc_pending' ?
                  <Fragment>
                    <img src={PtcLicense} style={{width: "70vw", maxWidth: "350px", margin: "2em 0"}} />
                    <p>
                      You are almost ready to drive with Autzu. Within 72 hours, your account will automatically be activated. 
                    </p>
                    <p>
                      You may be activated immediately if you already have a valid PTC License. 
                      Please email us your PTC License number and expiry date (or image of license) to <a href="/contact">info@autzu.com</a>.
                    </p>
                    <p>
                      We have sent more information about the need for a PTC License over email. 
                      For any questions please call the 24/7 Autzu hotline at <a href="tel:+18336928898">1-833-692-8898</a>.
                    </p>
                  </Fragment> :
                status === 'fleet_pending' ? 
                  <Fragment>
                    <div className="dashboard__container--notice">
                      {' '}
                      Thank you for signing up with Autzu - there is just one more step remaining!
                  </div>
                    <img className="dashboard__container--image" src={FleetPending} style={{ margin: "2em 0", minWidth: "190px", width: "70vw", maxWidth: "350px" }} />
                    <div className="dashboard__container--notice">
                      Please visit an Uber Greenlight Hub and ask an Uber Expert to add the Autzu fleet
                      to your Uber Driver account. After this step your Autzu account will be activated within 72 hours!
                    </div>
                    <div className="dashboard__container--via-locations">
                      <h5>Uber Greenlight Hubs: </h5>
                      <div className="dashboard__container--via-centre">
                        <img src={MapPin} />
                        <div>Toronto</div>
                          <a href="https://goo.gl/maps/x7gWknwapxn6nddr7" target="_blank">
                          120 Lynn Williams St., 2nd floor, Toronto, ON, M6K 3R6
                        </a>
                      </div>
                      <div className="dashboard__container--via-centre">
                        <img src={MapPin} />
                        <div>Scarborough</div>
                          <a href="https://goo.gl/maps/v9TFMNqegwf4xj4K7" target="_blank">
                          1457 McCowan Road, Suite 217, Scarborough, ON, M1S 5K7
                        </a>
                      </div>
                      <div className="dashboard__container--via-centre">
                        <img src={MapPin} />
                        <div>Mississauga</div>
                          <a href="https://goo.gl/maps/Nev3BGAZ937pfk3o6" target="_blank">
                          1980 Matheson Blvd E, Unit A Mississauga, ON, L4W 5N3
                        </a>
                      </div>
                    </div>
                  </Fragment> :
                helpOpen ? (
                  <HelpPage name={pageOpen} closePage={this.closePage} />
                ) : (
                  <Fragment>
                    <div className="dashboard__container--title">
                      {' '}
                      Your application has been successfully submitted and is currently being processed.
                    </div>
                    {this.getContent().map(element => (
                      <div
                        className={`dashboard__item dashboard__item--${element.class}`}
                        onClick={() => this.openPage(element.pageName, element.title)}>
                        {' '}
                        {element.status}{' '}
                        <div className="dashboard__item--content">
                          <div className="dashboard__item--title"> {element.title} </div>{' '}
                          <div className="dashboard__item--text">
                            {' '}
                            {element.text} <u> Click for more details </u>
                          </div>
                        </div>
                      </div>
                    ))}
                  </Fragment>
                )}
              </div>
            </ScrollLock>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default withApollo(withRouter(NewDashboard));



// WEBPACK FOOTER //
// ./src/components/NewDashboard/TorontoDashboard.js